var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAudioOn = function SvgAudioOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    fill: "none",
    fillRule: "evenodd",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 3,
    strokeWidth: 1.5,
    clipRule: "evenodd",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.62 9.017H2.99v13.966h4.63l6.983 6.983V2.033zM20.132 29.811zc.548-.205 1.096-.41 1.665-.673.569-.261 1.16-.58 1.743-.958s1.16-.817 1.654-1.244c.492-.426.9-.841 1.252-1.234s.647-.763.888-1.084c.241-.32.428-.591.603-.866.175-.276.337-.555.443-.739s.156-.271.269-.507.287-.618.46-1.04a13.864 13.864 0 0 0 .915-3.287c.102-.686.158-1.432.169-2.044s-.023-1.092-.08-1.595-.133-1.029-.262-1.638a13 13 0 0 0-.617-2.086 18 18 0 0 0-1.136-2.321 12 12 0 0 0-1.081-1.543 14 14 0 0 0-1.203-1.315c-.501-.481-1.151-1.039-1.83-1.513s-1.39-.863-1.918-1.127-.875-.401-1.167-.509-.53-.186-.767-.264"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.116 10.761c.149.13.299.262.409.364s.18.177.248.248v0c.068.072.133.14.244.266a5.9 5.9 0 0 1 .973 1.49c.17.365.319.778.419 1.156s.15.72.18 1c.03.281.041.499.039.781s-.018.63-.08 1.012-.174.8-.278 1.122a4.6 4.6 0 0 1-.351.828c-.15.28-.352.614-.556.9-.205.288-.411.528-.62.739s-.417.392-.627.573"
  })));
};
export default SvgAudioOn;